const useJurisdictionNameByJurisdictionType = (jurisdictionType: string) => {
    const jurisdictionNameByJurisdictionType = {
        ADGM: 'ADGM',
        CAYMAN: 'Cayman',
        DELAWARE: 'Delaware',
    };
    
    return jurisdictionNameByJurisdictionType[jurisdictionType] ?? '';
};
export default useJurisdictionNameByJurisdictionType;